import { useTranslator } from '../translator/hook'
import './smallButtonConnect.css'
import { useTooltip } from '../tooltipHook'
import { Tooltip } from '../tooltip'
import ConnectIcon from './icons/connectIcon'
import UnconnectIcon from './icons/unconnectIcon'

type Props = {
  connected: boolean
  onClick: () => void
  isWide: boolean
  tooltipLabel: string
  'aria-disabled'?: boolean
}

export const SmallButtonConnect = ({
  connected,
  onClick,
  isWide,
  tooltipLabel,
  ...rest
}: Props) => {
  const { t } = useTranslator()
  const { getReferenceProps, refs, tooltipProps } = useTooltip({
    placement: 'bottom-end',
  })
  return (
    <div
      ref={refs.setReference}
      {...getReferenceProps()}
      className={connected ? 'connect-small-button' : 'unconnect-small-button'}
      {...rest}
      onClick={() => (connected ? null : onClick())}
    >
      {tooltipLabel && (
        <Tooltip
          {...tooltipProps}
          className="linkage-button-tooltip"
          disabled={isWide}
        >
          {tooltipLabel}
        </Tooltip>
      )}
      {connected ?
        <ConnectIcon
          className={isWide ? 'icon_connect_wide' : 'icon_connect'}
        />
      : <UnconnectIcon
          className={isWide ? 'icon_unconnect_wide' : 'icon_unconnect'}
        />
      }

      {isWide && t(connected ? 'linked' : 'link')}
    </div>
  )
}
